import * as routes from '@/constants/routes';
import * as subjects from '@/constants/subjects';
import * as actions from '@/constants/actions';
import { canAbility, accessToEvents } from './middleware';
import RouterViewPassThrough from './RouterViewPassThrough';

export default {
  path: '/events',
  name: routes.EVENTS_PARENT,
  component: RouterViewPassThrough,
  redirect: { name: routes.EVENTS },
  meta: {
    middleware: [canAbility([actions.READ], subjects.EVENTS), accessToEvents()],
  },
  children: [
    {
      path: '/events',
      name: routes.EVENTS,
      component: () => import('@/views/Events/index.vue'),
    },
  ],
};
